import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { notify } from 'reapop';
import { store } from 'index';
import { escapeHTML } from 'utils/helper';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getFirstValue = (...values: any[]) =>
  values.find(value => value !== undefined && value !== null && value !== '');

export const getErrorMessage = (error: any) =>
  typeof error === 'string'
    ? error
    : getFirstValue(
    Array.isArray(error?.response?.data?.errors)
      ? error?.response?.data?.errors?.[0]?.message
      : undefined,
    Array.isArray(error?.response?.data?.data?.errors)
      ? error?.response?.data?.data?.errors?.[0]?.message
      : undefined,
    Array.isArray(error?.data?.errors)
      ? error?.data?.errors?.[0]?.message
      : undefined,
    Array.isArray(error?.errors) ? error?.errors?.[0]?.message : undefined,
    Array.isArray(error?.response?.data?.errorField)
      ? error?.response?.data?.errorField?.[0]?.message
      : undefined,
    Array.isArray(error?.data?.errorField)
      ? error?.data?.errorField?.[0]?.message
      : undefined,
    Array.isArray(error?.errorField)
      ? error?.errorField?.[0]?.message
      : undefined,
    Array.isArray(error?.response?.data?.data)
      ? error?.response?.data?.data?.[0]?.message
      : undefined,
    Array.isArray(error?.data?.data)
      ? error?.data?.data?.[0]?.message
      : undefined,
    error?.response?.data?.message,
    error?.data?.message,
    error?.message,
    'Có lỗi xảy ra, vui lòng thử lại',
  );

export function findMessage(obj: unknown): string | undefined {
  if (typeof obj === 'string') return undefined;
  const t = (store.getState().app as any)?.translations;
  if (obj && typeof obj === 'object') {
    const anyObj = obj as any;
    const status = anyObj?.status ?? anyObj?.response?.status;
    const message =
      anyObj?.response?.data?.message || // thường gặp nhất
      anyObj?.response?.data?.Message || // đôi khi viết hoa
      anyObj?.message;
    if (status === 403) return t?.['b2b.txt.noPermission'] || message;
    if (
      anyObj?.isNetworkError ||
      (anyObj?.message === 'Network Error' && !anyObj?.response)
    ) {
      return t('messages.BBC008');
    }

    if (message) {
      return message;
    }

    for (const key in obj) {
      // eslint-disable-next-line
      if (
        key.toLowerCase() === 'message' &&
        typeof (obj as any)[key] === 'string'
      ) {
        // eslint-disable-next-line
        return (obj as any)[key];
      }
      // eslint-disable-next-line
      const value = (obj as any)[key];
      if (typeof value === 'object') {
        const found = findMessage(value);
        if (found) return found;
      }
    }
  }

  return undefined;
}

export const showReservationErrorToast = (error: any) => {
  store.dispatch(
    notify(escapeHTML(getErrorMessage(error)), 'error', {
      title: 'Oops',
      dismissAfter: 5000,
    }),
  );
};

export const formatDateBEtoUTCFormat = (dateStr?: string) => {
  if (!dateStr) return '';
  if (dateStr?.includes('Z')) {
    return dateStr;
  } else return dateStr + 'Z';
};
